export default __webpack_public_path__ + "static/media/hand.af3fc088.png";